import axios from 'axios';
import {COMPARABLE_TYPE_TO_URI_MAP} from 'lib/Commons';
import {compact} from 'lodash/array';
import FetchAPI from 'api/FetchAPI';

async function getAdvertisementDescription(propertyId, comparableType) {
  const typeUri = COMPARABLE_TYPE_TO_URI_MAP[comparableType];
  const {data} = await axios.get(`/api/properties/${propertyId}/${typeUri}/advertisementDescription`);
  return data;
}

/**
 * @param propertyId
 * @returns {Promise<{defaultImageUri: string, floorPlanUris: string[], propertyPhotoList: string[], secondaryImageUris: string[]}>}
 */
async function getClPropertyPhotos(propertyId) {
  const {data} = await axios.get(`/api/properties/${propertyId}/corelogic/photos`);
  const {defaultImage, floorPlanImageList = [], secondaryImageList = []} = data;
  const defaultImageUri = getUrlFromClPhotoItem(defaultImage);
  const secondaryImageUris = secondaryImageList.map(i => getUrlFromClPhotoItem(i));
  const floorPlanUris = floorPlanImageList.map(i => getUrlFromClPhotoItem(i));
  const propertyPhotoList = compact([defaultImageUri, ...secondaryImageUris, ...floorPlanUris]);
  return {
    floorPlanUris,
    propertyPhotoList,
  };
}

/**
 * @param latitude
 * @param longitude
 * @param address
 * @returns {Promise<string>}
 */
async function getAerialMapPhoto(
  {
    latitude,
    longitude,
    address,
  }
) {
  return getGoogleMapPhoto({
    type: 'satellite',
    latitude,
    longitude,
    address,
  });
}

/**
 * @param latitude
 * @param longitude
 * @param address
 * @returns {Promise<string>}
 */
async function getStreetMapPhoto(
  {
    latitude,
    longitude,
    address,
  }
) {
  return getGoogleMapPhoto({
    type: 'street',
    latitude,
    longitude,
    address,
  });
}

async function getGoogleMapPhoto({
  latitude,
  longitude,
  address,
  type,
}) {
  const location = latitude && longitude ? `${latitude},${longitude}` : address;
  return FetchAPI.getText(`/api/google-maps/photo/${type}?location=${location}`);
}

function getUrlFromClPhotoItem(photoItem) {
  return photoItem.largePhotoUrl;
}

const ClapiApi = {
  getAdvertisementDescription,
  getAerialMapPhoto,
  getClPropertyPhotos,
  getStreetMapPhoto,
};

export default ClapiApi;
